export enum FlowSteps {
  ComponentLoaded = <any>'component-loaded',
  MobileRedirect = <any>'mobile-redirect',
  Landing = <any>'landing',
  Agreements = <any>'agreements',
  OtpSend = <any>'otp-send',
  OtpCheck = <any>'otp-check',
  CiFront = <any>'ci-front',
  CiFrontHowTo = <any>'ci-front-how-to',
  CiFrontCapture = <any>'ci-front-capture',
  CiBack = <any>'ci-back',
  CiBackHowTo = <any>'ci-back-how-to',
  CiBackCapture = <any>'ci-back-capture',
  CiTilt = <any>'ci-tilt',
  CiTiltHowTo = <any>'ci-tilt-how-to',
  CiError = <any>'ci-error',
  SelfieHowTo = <any>'selfie-how-to',
  SelfieTilt = <any>'selfie-tilt',
  SelfieCapture = <any>'selfie-capture',
  Selfie = <any>'selfie',
  SelfieError = <any>'selfie-error',
  End = <any>'end',
  CameraError = <any>'camera-error',
  Default = <any>'default',
}

export enum FlowMoments {
  Initialized = <any>'initialized',
  Finalized = <any>'finalized',
  None = <any>'none',
}
